/**
 * Нижняя навигация — плавающая пилюля.
 *
 * Кнопка «назад» у Telegram своя, поэтому здесь только переключение
 * разделов; вложенной навигации в табах нет.
 */
import { Icon, type IconName } from './Icon';
import styles from './TabBar.module.css';

export interface Tab {
  path: string;
  label: string;
  icon: IconName;
}

export function TabBar({
  tabs,
  current,
  onSelect,
}: {
  tabs: readonly Tab[];
  current: string;
  onSelect: (path: string) => void;
}) {
  return (
    <>
      {/* Растворение содержимого перед панелью. Отдельным элементом,
          а не псевдоэлементом панели: у той overflow не скрыт, но
          собственный фон, и градиент внутри неё был бы не виден. */}
      <span aria-hidden className={styles.fade} />

      <nav className={styles.bar}>
        {tabs.map((tab) => {
          const active = tab.path === current;
          return (
            <button
              key={tab.path}
              type="button"
              className={active ? `${styles.item} ${styles.active}` : styles.item}
              aria-current={active ? 'page' : undefined}
              onClick={() => onSelect(tab.path)}
            >
              <Icon name={tab.icon} size={21} />
              {tab.label}
            </button>
          );
        })}
      </nav>
    </>
  );
}
